import { observer } from 'mobx-react-lite';
import { oddStore } from '../../../../store';

export const ReportOdd = observer(({ gameTypeId }) => {
  const odd = oddStore.oddData[gameTypeId];

  return (
    <div className='pascal-game-col-top'>
      <div className='pascal-game-col-holder'>
        <div className='pascal-game-col-top-inside' />
        <div className='top-inner-shield-wrp' />
        <p className='pascal-game-col-top-coef'> x{odd} </p>
      </div>
    </div>
  );
});
